import { MemoryRouter as Router } from 'react-router-dom';

import type { Meta, StoryObj, StoryFn } from '@storybook/react';

import { ConversationView } from './Conversation';

export default {
  title: 'features/Conversation',
  component: ConversationView,
  decorators: [
    (Story: StoryFn<typeof Router>) => (
      <div style={{ padding: '10vh 20px', height: '100svh', placeContent: 'center' }}>
        <Story />
      </div>
    ),
  ],
} as Meta;

export const Basic: StoryObj<typeof ConversationView> = {
  args: {
    role: 'fushima',
    name: 'フシマ',
    displayAvatar: true,
    body: '宝物...？よくわかんないけど、どうしたらいいの？',
    showName: true,
  },
};

export const WithoutName: StoryObj<typeof ConversationView> = {
  args: {
    role: 'amana',
    name: 'アマナ',
    displayAvatar: true,
    body: 'この会話では名前が表示されません。名前を非表示にすると、自動的に大きいサイズ（lg）のメッセージボックスになります。',
    showName: false,
  },
};
